import React from 'react'

import medal from '../../../../images/mirea/number1.svg'
import bootable from '../../../../images/mirea/number2.svg'
import gal from '../../../../images/mirea/number3.svg'

import styles from './styles.module.scss'

const AboutPrograms = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <p className={styles.about_company}>О программе</p>
        <div className={styles.list}>
          <div className={styles.item}>
            <p className={styles.number}>2 года</p>
            <p className={styles.text_lg}>
              продолжительность обучения
            </p>
          </div>
          <div className={styles.item}>
            <p className={styles.number}>5</p>
            <p className={styles.text_lg}>
              дипломных проектов ежегодно
            </p>
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.right_wrapper}>
          <p className={styles.title}>
            Разработка процессов производства биотехнологических лекарственных средств
          </p>
          <p className={styles.title_p1}>
            Mabstudy включает в себя научно-образовательные лаборатории в вузе, лекционный курс от экспертов компании и программу стажировок, позволяющую получить уникальное биофармацевтическое образование и стать частью команды Generium.
          </p>
          <p className={styles.title_p2}>
            Лаборатории находятся на кафедре биотехнологии и промышленной фармации РТУ МИРЭА и открыты для магистров любых профильных вузов, а лучшие выпускники могут получить приглашение на работу.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AboutPrograms
